
export default {
  fontFamily: [
    'OktaNeueRegular',
    'Courier'
  ].join(',')
}
